import axiosBasicInstance from '../axiosConfig';

const getListGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/list-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getListUserGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/list-user-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getListAdminGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/list-admin-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/add-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/delete-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteGroupAdmin = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/delete-group-admin', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/update-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateUserToGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/update-user-to-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateAdminToGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/update-admin-to-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteAllUserToGroup = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/delete-all-user-group', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const exportUserGroupCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/export-user-group', data, {
         responseType: 'blob'
      });
      return response;
   } catch (error) {
      throw error;
   }
};



export { getListGroup, 
         getListUserGroup,
         addGroup,
         deleteGroup,
         updateGroup,
         updateUserToGroup,
         deleteAllUserToGroup,
         updateAdminToGroup,
         getListAdminGroup,
         deleteGroupAdmin,
         exportUserGroupCSV
        };
